var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section section--white"},[_c('div',{staticClass:"donation-technical-error"},[_c('VueFeedback',{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v("Technikai hiba történt!")]),_c('template',{slot:"feedback-content"},[_c('p',[_vm._v("Technikai hiba történt! Kérjük később próbálja újra!")])])],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }